// Corner radius for card surfaces (cards, page header, table containers)
export const CARD_RADIUS = '16px';
